import { DatePipe, JsonPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { Basket } from 'ish-core/models/basket/basket.model';
import { IntervalFormatterPipe } from 'ish-core/pipes/interval-formatter.pipe';

@Component({
  selector: 'custom-basket-recurrence',
  templateUrl: './basket-recurrence.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, DatePipe, JsonPipe, IntervalFormatterPipe],
})
export class BasketRecurrenceComponent {
  readonly basket = input<Basket>(undefined);
  constructor() {
    console.debug(this.basket());
  }
}
